<template>
  <b-modal
    class="subscriptionPlansModal"
    hide-header
    hide-footer
    centered
    size="lg"
    ref="subscriptionPlansModal"
    @open="open"
  >
    <b-card-group deck>
      <b-card>
        <span slot="header">Developer</span>
        <div class="planCostInfo d-flex flex-column align-items-center my-4">
          <span class="price">Free</span>
          <span class="range text-muted">Up to</span>
        </div>
        <div class="planOptionsInfo d-flex flex-column align-items-center text-secondary my-2">
          <span>200 receipts / mo</span>
          <span>7 day receipt history</span>
          <span>Weblink & QR codes</span>
          <del>Remove Branding</del>
        </div>
        <template v-if="currentPlanName === 'developer'">
          <p-button slot="footer" round type="success" disabled>Current Plan</p-button>
        </template>
        <template v-else>
          <p-button slot="footer" round type="success" @click.native="updateSubscription('developer')" :loading="processing">Downgrade</p-button>
          <b-loading :loading="processing" />
        </template>
      </b-card>
      <b-card>
        <span slot="header">Business</span>
        <div class="planCostInfo d-flex flex-column align-items-center my-4">
          <span class="price"><sup>$</sup>15</span>
          <span class="range text-muted">/ MONTH</span>
        </div>
        <div class="planOptionsInfo d-flex flex-column align-items-center text-secondary my-2">
          <span>2,500 receipts / mo</span>
          <small>+$0.01 per extra receipt</small>
          <span>30 day receipt history</span>
          <span>Weblink & QR codes</span>
          <span>Remove Branding</span>
        </div>
        <template v-if="currentPlanName === 'business'">
          <p-button slot="footer" round type="success" disabled>Current Plan</p-button>
        </template>
        <template v-else>
          <p-button slot="footer" round type="success" @click.native="updateSubscription('business')" :loading="processing">Upgrade</p-button>
          <b-loading :loading="processing" />
        </template>
      </b-card>
    </b-card-group>
  </b-modal>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      processing: false,
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'stripeCustomer',
      'stripeSubscription',
    ]),
    currentPlanName: function() {
      return this.user && this.user.subscription_plan || ''
    }
  },
  methods: {
    open() {
      this.$refs.subscriptionPlansModal.show()
    },
    updateSubscription(targetPlan) {
      this.processing = true
      const {uid, customer_id, subscription_id, usage} = this.user
      const timestamp = Math.floor(+new Date() / 1000)
      const payload = {
        uid,
        usage: usage.current,
        timestamp,
        customer_id,
        subscription_id,
        subscription_item_id: this.stripeSubscription.items.data[0].id,
        targetPlan
      }
      this.$store.dispatch('updateSubscription', payload)
      .finally(() => {
        this.processing = false
        this.$refs.subscriptionPlansModal.hide()
      })
    },
    // downgradeToDeveloper() {
    //   this.processing = true
    //   const {uid, customer_id, subscription_id, usage} = this.user
    //   this.$store.dispatch('downgradeStripeSubscription', {
    //     uid,
    //     usage: usage.current,
    //     customer_id,
    //     subscription_id,
    //     subscription_item_id: this.stripeSubscription.items.data[0].id,
    //     targetPlan: 'developer'
    //   }).finally(() => {
    //     this.processing = false
    //     this.$refs.subscriptionPlansModal.hide()
    //   })
    // },
    // upgradeToBusiness() {
    //   this.processing = true
    //   const {uid, customer_id, subscription_id, usage} = this.user
    //   this.$store.dispatch('upgradeStripeSubscription', {
    //     uid,
    //     usage: usage.current,
    //     customer_id,
    //     subscription_id,
    //     subscription_item_id: this.stripeSubscription.items.data[0].id,
    //     targetPlan: 'business'
    //   }).finally(() => {
    //     this.processing = false
    //     this.$refs.subscriptionPlansModal.hide()
    //   })
    // }
  },
}
</script>
<style lang="scss">
.subscriptionPlansModal {
  .modal-content {
    background: none;
    border: 0 none;
  }
  .card {
    .card-header {
      padding-bottom: 20px;
      background: linear-gradient(46.77deg, #00C0F3 0%, #01BFED 18%, #02BEDB 44%, #05BBBD 76.37%, #08B89D 100%);
      color: #fff;
      text-align: center;
      font-size: 18px;
    }
    .planCostInfo {
      .price {
        font-weight: 900;
        font-size: 48px;
        line-height: 1;
      }
      .range {
        font-weight: 100;
        font-size: 18px;
      }
    }
    .planOptionsInfo {
      span {
        line-height: 2;
      }
      del, small {
        opacity: 0.5;
      }
    }
    .card-footer {
      background: none;
      border-top: 0 none;
      text-align: center;
      padding-bottom: 30px;
      .btn {
        background: #2DD4AE;
        min-width: 200px;
        border: 0 none;
        font-size: 16px;
        text-transform: initial;
        &:disabled {
          opacity: 1;
          background: #DCDCDC;
        }
      }
    }
  }
}
</style>
